var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 60,
            "min-height": 90,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._t("text-title"),
              ],
              2
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c(
              "div",
              [
                _vm.innerEmailer &&
                _vm.isActiveImageSelect &&
                !_vm.isDocAttachActive
                  ? _c("image-select", {
                      attrs: {
                        "quote-id": _vm.innerEmailer.assetId,
                        "quote-ids": _vm.attachmentOptions.selectedQuotes.map(
                          (q) => q.value
                        ),
                        subtitle: `Select images to attach`,
                      },
                      on: { input: _vm.getSelectedImage },
                      model: {
                        value: _vm.imagesSelectedForAttachment,
                        callback: function ($$v) {
                          _vm.imagesSelectedForAttachment = $$v
                        },
                        expression: "imagesSelectedForAttachment",
                      },
                    })
                  : _vm._e(),
                _vm.innerEmailer &&
                _vm.isDocAttachActive &&
                !_vm.isActiveImageSelect
                  ? _c("attachment-select", {
                      attrs: {
                        "quote-id": _vm.innerEmailer.assetId,
                        subtitle: `Select documents to attach`,
                      },
                      on: { input: _vm.onDocumentsSelected },
                      model: {
                        value: _vm.documentsSelectedForAttachment,
                        callback: function ($$v) {
                          _vm.documentsSelectedForAttachment = $$v
                        },
                        expression: "documentsSelectedForAttachment",
                      },
                    })
                  : _vm._e(),
                _vm.isActiveAttachment
                  ? _c("quote-email-attachments", {
                      attrs: {
                        "quote-id": _vm.innerEmailer.assetId,
                        "email-id": _vm.innerSelectedAttachmentEmailId,
                        "is-incoming": _vm.isIncoming,
                      },
                      on: { close: _vm.closeAttachmentsModel },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _vm.isActiveImageSelect && !_vm.isDocAttachActive
                ? _c(
                    "button",
                    {
                      staticClass: "button is-success tooltip",
                      attrs: {
                        "data-tooltip": "Done",
                        disabled: !_vm.canAttach,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.ok()
                        },
                      },
                    },
                    [_c("span", [_vm._v("Ok")])]
                  )
                : _vm._e(),
              _vm.isDocAttachActive && !_vm.isActiveImageSelect
                ? _c(
                    "button",
                    {
                      staticClass: "button is-success tooltip",
                      attrs: {
                        "data-tooltip": "Done",
                        disabled: !_vm.documentsSelectedForAttachment.length,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.ok()
                        },
                      },
                    },
                    [_c("span", [_vm._v("Ok")])]
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: {
                    "data-tooltip": _vm.cancelInWording,
                    disabled: _vm.cancelDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.cancelInWording))]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }